import React, { useState } from 'react';
import { Box, Container, Stack, Breadcrumbs, Link, Typography } from '@mui/material';
import ClassificationBannerHeader from '../common/banner/classifactionBannerHeader';
import PageHeader from '../common/banner/pageHeader';
import { useLocation, useNavigate } from 'react-router-dom'

export default function HostInformation() {
  const baseRoute = process.env.REACT_APP_BASE_ROUTE || '/';
  const mac1 = baseRoute + 'images/hostInfo/host1.png';
  const mac2 = baseRoute + 'images/hostInfo/host2.png';
  const mac3 = baseRoute + 'images/hostInfo/host3.png';
  const mac4 = baseRoute + 'images/hostInfo/host4.png';
  const mac5 = baseRoute + 'images/hostInfo/host5.png';
  const mac6 = baseRoute + 'images/hostInfo/host6.png';
  const ip1 = baseRoute + 'images/hostInfo/ipv4_1.png';
  const ip2 = baseRoute + 'images/hostInfo/ipv4_2.png';
  const ip3 = baseRoute + 'images/hostInfo/ipv4_3.png';
  const ip4 = baseRoute + 'images/hostInfo/ipv4_4.png';
  const ip5 = baseRoute + 'images/hostInfo/ipv4_5.png';
  const ip6 = baseRoute + 'images/hostInfo/ipv4_6.png';
  const ip7 = baseRoute + 'images/hostInfo/ipv4_7.png';
  const ip8 = baseRoute + 'images/hostInfo/ipv4_8.png';
  const ip9 = baseRoute + 'images/hostInfo/ipv4_9.png';
  const { state } = useLocation();
  const value = state?.host || state?.ipv4 || {};
  const navigate = useNavigate();
  const title = 'Sensor 001';

  const getImage = (v) => {
    switch(v) {
      case '00:0c:29:43:d6:e9':
        return mac1;
      case '00:0c:29:60:4d:60':
        return mac2;
      case '00:0c:29:78:c3:cd':
        return mac3;
      case '00:0c:29:81:77:9b':
        return mac5;
      case '00:0c:29:7d:72:26':
        return mac4;
      case '00:0c:29:a0:9b:6b':
        return mac6;
      case '10.1.2.17':
        return ip1;
      case '10.1.2.189':
        return ip2;
      case '10.1.2.192':
        return ip3;
      case '10.1.2.210':
        return ip4;
      case '10.1.2.229':
        return ip5;
      case '10.1.2.233':
        return ip6;
      case '10.1.2.18':
        return ip7;
      case '192.168.1.11':
        return ip8;
      case '192.168.1.50':
        return ip9;
      default:
        return ip9;
    }
  };

  const handleBreadcrumbClick = () => {
    navigate('/neters');
  }
  
  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="Host"></PageHeader>
      </Box>
      <Box>
      <Stack  sx={{ width: '47%', paddingLeft: 0, marginLeft: 0}} spacing={{ md: 4 }}  >
                <Breadcrumbs aria-label="breadcrumb" zIndex='1'>
                    <Link underline="hover" color="#c1d4e7" onClick={handleBreadcrumbClick} sx={{ '&:hover': { cursor: 'pointer' } }}>
                        NeTERS
                    </Link>
                    <Typography color="white"> / </Typography>
                    <Typography color="white">{ title }</Typography>
                </Breadcrumbs>
            </Stack>
      </Box>
      <Box
        sx={{          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      > 
      {getImage(value) && (
      <img src={getImage(value)}
            width="100%"
            height="100%"
            style={ getImage(value).includes('ip') 
            ? {border: 'none', display: 'wrap', objectFit: 'contain', marginBottom: '-70px'}
            : {border: 'none', display: 'wrap', objectFit: 'none', marginTop: '-70px', marginBottom: '-140px'}}
              >
      </img>)}
      </Box>
      
    </Container>
  );
};